import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Component imports
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage/HomePage';
import CreateSecretPage from './pages/CreateSecretPage/CreateSecretPage';
import RetrieveSecretPage from './pages/RetrieveSecretPage/RetrieveSecretPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';

// Context imports
import { ApiProvider } from './context/ApiContext';
import { AuthProvider } from './context/AuthContext';

import './App.css';

function App() {
  return (
    <div className="App">
      {/* PROVIDE authentication context to entire app */}
      <AuthProvider>
        {/* PROVIDE API context with authentication support */}
        <ApiProvider>
          {/* CONFIGURE application routing */}
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/create" element={<CreateSecretPage />} />
              <Route path="/secret/:id" element={<RetrieveSecretPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>

          {/* DISPLAY toast notifications for user feedback */}
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </ApiProvider>
      </AuthProvider>
    </div>
  );
}

export default App;